import { call } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchROPicklists as fetchROPicklistsRoutine,
  fetchROPicklistForEdit as fetchROPicklistForEditRoutine,
  fetchROPicklistForView as fetchROPicklistForViewRoutine,
  createROPicklist as createROPicklistRoutine,
  updateROPicklist as updateROPicklistRoutine,
  deleteROPicklist as deleteROPicklistRoutine,
  updateROPicklistSorting as updateROPicklistSortingRoutine
} from './routines';
import { reservationsROPicklistViewPath } from '../../../../routes/Paths';
import history from '../../../../routes/history';
import pagePathToUrl from '../../../../helpers/pagePathToUrl';

export const fetchROPicklists = ({ payload: qs }) =>
  sagaRoutineRequest(fetchROPicklistsRoutine, {
    request: () => call(Api.fetchROPicklists, { qs })
  });

export const fetchROPicklistForEdit = ({ payload: id }) =>
  sagaRoutineRequest(fetchROPicklistForEditRoutine, {
    request: () => call(Api.fetchROPicklist, id)
  });

export const fetchROPicklistForView = ({ payload: id }) =>
  sagaRoutineRequest(fetchROPicklistForViewRoutine, {
    request: () => call(Api.fetchROPicklist, id)
  });

export const createROPicklist = ({ payload: { body } }) =>
  sagaRoutineRequest(createROPicklistRoutine, {
    request: () => call(Api.createROPicklist, { body }),
    *success({ id }) {
      yield toastr.success('Success', 'Pick List successfully created.');
      history.push(pagePathToUrl(reservationsROPicklistViewPath, { id }));
    }
  });

export const updateROPicklist = ({ payload: { id, body } }) =>
  sagaRoutineRequest(updateROPicklistRoutine, {
    request: () => call(Api.updateROPicklist, { id, body }),
    *success() {
      yield toastr.success('Success', 'Pick List successfully updated.');
      history.push(pagePathToUrl(reservationsROPicklistViewPath, { id }));
    }
  });

export const updateROPicklistSorting = ({ payload: { id, body } }) =>
  sagaRoutineRequest(updateROPicklistSortingRoutine, {
    request: () => call(Api.updateROPicklist, { id, body })
  });

export const deleteROPicklist = ({ payload: { name, id } }) =>
  sagaRoutineRequest(deleteROPicklistRoutine, {
    request: () => call(Api.deleteROPicklist, id),
    successPayload: { id },
    *success() {
      yield toastr.success('Success', `Deleted Pick List "${name}".`);
    }
  });
